import { Formik, Form } from 'formik'
import { isNil, omitBy, pipe } from 'lodash/fp'
import Styles from './ReviewTemplateForm.module.scss'
import { ReviewTemplateFormProps, TemplateFormData } from '../Types'
import { emptyTemplate, templateSubmissionFieldsFromFormData, notEmpty, isValidDaysAhead } from './utils'
import { NameField } from './components/NameField'
import { MemberSelectors } from './components/MemberSelectors'
import { RichTextMessage } from './components/Message'
import { Button } from 'components/Button'
import { DueDate } from './components/DueDate'
import { ConditionalWrapper } from 'common/ConditionalWrapper/ConditionalWrapper'
import { Portal } from 'components/Portal/Portal'

export const ReviewTemplateForm = ({ initialTemplate, onSubmit, footerPortal }: ReviewTemplateFormProps) => {
  const initialValues = initialTemplate ?? emptyTemplate()
  const validate = (values: TemplateFormData) => {
    const errors: Partial<Record<keyof TemplateFormData, string>> = {
      name: notEmpty(values.name),
      days_ahead: isValidDaysAhead(values.days_ahead),
    }
    return omitBy(isNil, errors)
  }

  return (
    <Formik
      initialValues={{ ...initialValues }}
      onSubmit={(values, { setSubmitting }) => {
        pipe(templateSubmissionFieldsFromFormData, onSubmit, () => setSubmitting(false))(values)
      }}
      validate={validate}
      validateOnBlur={false}
    >
      {(form) => (
        <Form>
          <div className={Styles.form}>
            <NameField isDisabled={form.isSubmitting} />
            <MemberSelectors
              initialViewers={initialValues.viewers}
              initialApprovers={initialValues.approvers}
              isDisabled={form.isSubmitting}
            />
            <DueDate isDisabled={form.isSubmitting} />
            <RichTextMessage isDisabled={form.isSubmitting} />
          </div>
          <ConditionalWrapper
            condition={!!footerPortal}
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            wrapper={(children) => <Portal container={footerPortal!}>{children}</Portal>}
          >
            <Button onPress={form.submitForm} size="xl" type="submit" isDisabled={!form.isValid || form.isSubmitting}>
              Save template
            </Button>
          </ConditionalWrapper>
        </Form>
      )}
    </Formik>
  )
}
